import {
  BankAccountInfiniteSelectField,
  CnpjFormField,
  CpfFormField,
  FloatingFormItem,
  InputText,
} from '@/components/_common';
import CostCenterInfiniteSelectField from '@/components/_common/CostCenterInfiniteSelectField';
import {
  Col,
  Divider,
  Form,
  FormInstance,
  Input,
  Radio,
  Row,
  Typography,
} from 'antd';
import React from 'react';
import { InstallmentsAdvancedFilterFormValues } from '..';
import RadioGroup from '@/components/_common/RadioGroup';
import { FormattedMessage } from 'react-intl';

interface Props {
  form: FormInstance<InstallmentsAdvancedFilterFormValues>;
}

const RegisterDataAccountPayable: React.FC<Props> = ({ form }) => {
  const personTypeWatch = Form.useWatch('personType', form);

  return (
    <>
      <Typography.Title level={4} style={{ margin: 0 }}>
        Pesquisar por dados do registro financeiro
      </Typography.Title>

      <Divider style={{ margin: 0, marginBottom: 24 }} />

      <Row gutter={[12, 12]}>
        <Col span={24}>
          <Form.Item noStyle name="personType" initialValue="NATURAL">
            <RadioGroup style={{ marginBottom: '8px' }}>
              <Radio value="NATURAL">
                <FormattedMessage id="customers.domain.personType.natural" />
              </Radio>
              <Radio value="LEGAL">
                <FormattedMessage id="customers.domain.personType.legal" />
              </Radio>
            </RadioGroup>
          </Form.Item>
        </Col>

        <Col span={24} md={8}>
          {personTypeWatch === 'NATURAL' ? (
            <CpfFormField
              label="CPF do Fornecedor"
              fieldName="cnpjCreditor"
              required={false}
            />
          ) : (
            <CnpjFormField
              label="CNPJ do Fornecedor"
              fieldName="cnpjCreditor"
              required={false}
            />
          )}
        </Col>

        <Col span={24} md={8}>
          <FloatingFormItem label="Código Compra" name="purchaseCode">
            <InputText onlyNumber />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={8}>
          <FloatingFormItem
            label="Número do Documento (Compra Agrupada)"
            name="purchasingDocumentNumber"
          >
            <Input />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={8}>
          <FloatingFormItem label="Número do Documento" name="documentNumber">
            <Input />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={8}>
          <FloatingFormItem label="Conta bancária" name="bankAccountId">
            <BankAccountInfiniteSelectField
              allowClear
              queryFilter={{ active: true }}
            />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={8}>
          <FloatingFormItem label="Centro de Custo" name="costCenterId">
            <CostCenterInfiniteSelectField allowClear />
          </FloatingFormItem>
        </Col>
      </Row>
    </>
  );
};

export default RegisterDataAccountPayable;
